import EditSaveCancelButtons from '../../../ui/edit-save-cancel-buttons';
import RichTextViewer from '../../../../library/ckeditor/rich-text-viewer';
import PolicyContentHeaderAction from '../common/policy-data-page/policy-content-header-action';

interface Props {
    title: string;
    description?: string;

    isEditing: boolean;
    onEdit: () => void;
    onCancel: () => void;
    onSave: () => void;

    value: string;

    parentStyle?: string
}

export default function PolicyCKEditorTextModal({ title, description, isEditing, onEdit, onCancel, onSave, value, parentStyle = 'border border-gray-300 rounded overflow-hidden' }: Props) {
    return (
        <div className={parentStyle}>
            <div className="bg-[#eef6fc] border-b border-gray-300 px-3 py-3">
                <div className="flex flex-row items-start justify-between gap-2 md:gap-4">
                    <PolicyContentHeaderAction
                        title={title}
                        subTitle={description}
                    />
                    <EditSaveCancelButtons
                        isEditing={!isEditing}
                        onEdit={onEdit}
                        onCancel={onCancel}
                        onSave={onSave}
                    />
                </div>
            </div>
            <div className="p-2">
                <div className="px-2 py-2">
                    <RichTextViewer value={value} />
                </div>
            </div>
        </div>
    )
}
